import React from "react"
import types from "prop-types"
import clsx from "clsx"
import GlobalHeaderNavItemContent from "./GlobalHeaderNavItemContent"

const GlobalHeaderNavLinkItem = ({
  title, icon, path, isActiveTab, index, tabRef, navIsHorizontal, handleKeyDown, onClick,
}) => {
  const itemId = `item-${title}`

  return (
    <li role="presentation">
      <a
        className={clsx("activity-hub-main-nav-list-item", isActiveTab && "active")}
        href={path}
        tabIndex={isActiveTab ? 0 : -1}
        onClick={onClick}
        onKeyDown={(e) => handleKeyDown(e, index)}
        ref={(el) => {
          tabRef.current[index] = el
        }}
        aria-label={title}
        role={navIsHorizontal ? "tab" : "menuitem"}
      >
        <GlobalHeaderNavItemContent icon={icon} isActiveTab={isActiveTab} title={title} itemId={itemId} />
      </a>
    </li>
  )
}

GlobalHeaderNavLinkItem.propTypes = {
  title: types.string.isRequired,
  icon: types.string.isRequired,
  path: types.string.isRequired,
  isActiveTab: types.bool.isRequired,
  index: types.number.isRequired,
  tabRef: types.shape({ current: types.array }).isRequired,
  navIsHorizontal: types.bool.isRequired,
  handleKeyDown: types.func.isRequired,
  onClick: types.func.isRequired,
}

export default GlobalHeaderNavLinkItem
